import type { SystemStyleObject } from '@mui/system';
import type { Theme } from '@mui/material';

import { theme } from '@theguarantors/tg-package-material-ui';

const calendarCellStates = {
  '&:not(.Mui-selected)': {
    '&:hover': {
      backgroundColor: '#E7E7E7',
    },
    '&:focus, &:active': {
      backgroundColor: '#D1D1D1',
    },
  },
  '&.Mui-selected': {
    backgroundColor: '#080A2D !important',
    color: '#FFFFFF !important',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#080A2D !important',
      color: '#FFFFFF !important',
    },
  },
};

export const leaseDatePickerStyles = {
  inputAdornment: {
    marginLeft: '4px',
  },
  openPickerButton: {
    padding: 0,
  },
  actionBar: {
    padding: '8px 12px 12px 12px',
    justifyContent: 'flex-end',
  },
  datePicker: {
    width: '100%',
    '& .MuiFilledInput-root, & .MuiPickersFilledInput-root': {
      borderRadius: '4px !important',
      '&::before': {
        display: 'none !important',
      },
      '&::after': {
        display: 'none !important',
      },
    },
    // Match other lease fields' error fill (red[50] + red inset ring). Keep
    // transparent only on non-error so it doesn't wipe the error background.
    '& .MuiFilledInput-root.Mui-error, & .MuiPickersFilledInput-root.Mui-error': {
      backgroundColor: `${theme.palette.red[50]} !important`,
      border: 'none !important',
      boxShadow: `0 0 0 2px ${theme.palette.red[600]} inset !important`,
      '&:hover, &.Mui-focused': {
        backgroundColor: `${theme.palette.red[50]} !important`,
        boxShadow: `0 0 0 2px ${theme.palette.red[600]} inset !important`,
      },
    },
    '& .MuiFilledInput-root:not(.Mui-error), & .MuiPickersFilledInput-root:not(.Mui-error)': {
      backgroundColor: 'transparent !important',
      border: 'none',
      boxShadow: '#888888 0px 0px 0px 1px inset !important',
      '&:hover': {
        backgroundColor: 'transparent !important',
        boxShadow: '#1D1D1D 0px 0px 0px 1px inset !important',
      },
      '&.Mui-focused': {
        backgroundColor: 'transparent !important',
        boxShadow: '#1D1D1D 0px 0px 0px 2px inset !important',
      },
    },
    '& .MuiButtonBase-root': {
      marginRight: '-4px !important',
    },
    '& .MuiInputLabel-root, & .MuiFormLabel-root': {
      color: '#5D5D5D',
      '&.Mui-focused': {
        color: '#5D5D5D',
      },
    },
  },
  redAsterisk: {
    '& .MuiFormLabel-asterisk': {
      color: `${theme.palette.red[600]} !important`,
    },
  },
  day: {
    fontSize: '16px',
    ...calendarCellStates,
  },
  monthButton: {
    fontSize: '16px',
    borderRadius: '100px',
    ...calendarCellStates,
  },
  yearButton: {
    fontSize: '16px',
    fontWeight: 400,
    borderRadius: '100px',
    ...calendarCellStates,
  },
} as const;

type AsteriskSxOptions = {
  asteriskColor?: string;
  redAsterisk?: boolean;
};

export const getLeaseDateAsteriskSx = ({
  asteriskColor,
  redAsterisk = false,
}: AsteriskSxOptions): SystemStyleObject<Theme> | undefined => {
  if (asteriskColor) {
    return { '& .MuiFormLabel-asterisk': { color: `${asteriskColor} !important` } };
  }

  return redAsterisk ? leaseDatePickerStyles.redAsterisk : undefined;
};
